import React, { useState, useEffect } from "react";
import {
  startOfMonth,
  startOfWeek,
  endOfWeek,
  endOfMonth,
  eachDayOfInterval,
  format,
} from "date-fns";
import moment from "moment";
import { ResourceBookingSchema, ResourceSchema, TimeBlock, DayScheduleType } from "../data/types";
import {  
  areDatesInSameMonth, areBookingsLessThan12Hours, 
  findBookingsForDay, calculateAvailableTimeBlocks, 
  isTimeSlot, dayAvailability, calculateAvailableBlocksForDay } from '../utils/helpers';
// import { getResourceOptions } from "../api/crud";
// import { darkenColor, getBookingStatusColor } from "../utils/helpers";

type MonthViewProps = {
  currentCalendarDate: Date;
  selectedDay: Date;
  resourceBookings: Array<ResourceBookingSchema>;
  // userBookings: Array<ResourceBookingSchema>;
  nHours: number;
  handleDateChange: (date: Date) => void;
  handleConfirmBooking?: () => void;
  currentResource: ResourceSchema;
  setBlocks:React.Dispatch<React.SetStateAction<TimeBlock[] | undefined>>
};



const ReservationCalendar: React.FC<MonthViewProps> = ({
  // userBookings,
  resourceBookings,
  currentCalendarDate,
  nHours,
  currentResource,
  setBlocks,
  selectedDay,
  handleDateChange
}) => {


  // const [selectedBlock, setSelectedBlock] = useState<TimeBlock>();
  // const [selectedDay, setSelectedDay] = useState(new Date());
  const [bookings, setBookings] = useState<ResourceBookingSchema[]>([]);

  const firstDayOfMonth = startOfWeek(startOfMonth(currentCalendarDate));
  const lastDayOfMonth = endOfWeek(endOfMonth(currentCalendarDate));

  const daysInMonth: Date[] = eachDayOfInterval({
    start: firstDayOfMonth,
    end: lastDayOfMonth,
  });
  

  useEffect(() => {
    const createCurrentBookings = () => {
      const safeBookings = resourceBookings || [];
      const combinedBookings = safeBookings.filter((booking, index, self) =>
        index === self.findIndex((b) => b.id === booking.id)
      );
      setBookings(combinedBookings);
    };
    createCurrentBookings();
    // if (currentCalendarDate){
    //   handleCalendarClick(firstDayOfMonth)
    // }
  }, [resourceBookings]); // Run when either booking array changes
  



  const handleCalendarClick = async (day: Date) => {
    try {
      // Early return if basic conditions aren't met
      if (!areDatesInSameMonth(day, currentCalendarDate) || !areBookingsLessThan12Hours(day, bookings || []) || nHours <= 0) {
        return;
      }

      const dayOfWeek = moment(day).format("ddd").toLowerCase();
      const dayOptions = currentResource.resource_options?.[dayOfWeek] as DayScheduleType | DayScheduleType[] | undefined;
      
      if (!dayOptions || !isTimeSlot(dayOptions)) {
        return;
      }

      let availableBlocks: TimeBlock[] = [];
      if (Array.isArray(dayOptions)) {
        availableBlocks = calculateAvailableBlocksForDay(
          dayOptions,
          nHours,
          findBookingsForDay(moment(day), bookings || [])
        );
      } else {
        availableBlocks = calculateAvailableTimeBlocks(
          dayOptions.open_time,
          dayOptions.close_time,
          nHours,
          findBookingsForDay(moment(day), bookings || [])
        );
      }

      if (availableBlocks.length > 0) {
        handleDateChange(day);
        setBlocks(availableBlocks);
      }
    } catch (error) {
      console.error('Error in handleCalendarClick:', error);
    }
  };

  

  return (
    <div className="flex flex-col w-full justify-center place-items-center">
      <div className="grid grid-cols-7 gap-1 gap-y-3 grid-flow-dense w-full">
        {(daysInMonth && daysInMonth?.length > 0) && daysInMonth.slice(0, 7)?.map((day) => (
          <div
            key={day.toISOString()}
            className=" text-[#4D4D4D] text-[16px] font-raleway  p-2 relative col-span-1 text-left md:px-5  "
          >
            <div>{format(day, "E")}</div>
          </div>
        ))}

        {(daysInMonth && daysInMonth?.length > 0) ? daysInMonth.map((day, i) => (
          <div 
            key={i} 
            data-testid={`calendar-day-${format(day, 'yyyy-MM-dd')}`}
            className={`font-medium px-[14px] py-[2px] pb-2 relative col-span-1 border-[1px] border-[#E9E9E9] rounded-md h-[45px] w-[65px]  
              ${(day && selectedDay && moment.utc(day).isSame(moment.utc(selectedDay), 'day')) ? "bg-primaryDark-100 text-white" : (
                  ((day && !dayAvailability(day, currentResource, nHours, bookings || []))) ? "!text-gray-300 cursor-not-allowed bg-transparent" : (
                    (day && (!areBookingsLessThan12Hours(day, bookings || []) || moment().isSameOrAfter(moment(day))))
                        ? "bg-transparent text-gray-300 cursor-not-allowed"
                        : "hover:bg-primaryDark-400 cursor-pointer hover:text-white"
                  )
                )
              }
            `}
            onClick={(e) => {
              e.stopPropagation();
              handleCalendarClick(day);
            }}
          >
            <div
              className={`
                ${areDatesInSameMonth(day, currentCalendarDate) ? "" : "!text-transparent"}
                justify-center md:m-2 text-center md:w-1/4 rounded-full md:pt-1
              `}
            >
              {format(day, "dd")}
            </div>
          </div>
        )) : (<></>)}
      </div>
    </div>
  );
};



export default ReservationCalendar;
